import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checkbox-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_checkbox = _resolveComponent("base-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkboxes, (value) => {
      return (_openBlock(), _createBlock(_component_base_checkbox, {
        label: value.label,
        value: value.value,
        checked: value.checked,
        onCheckboxUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event))),
        key: value.value
      }, null, 8, ["label", "value", "checked"]))
    }), 128))
  ]))
}